import {TableColumn} from "@/models/table/TableColumn.ts";

const IdentityProviderGroupColunms : TableColumn[] = [
    {
        heading:"Name",
        accessor: "idpGroupName",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "name"
    },
    {
        heading:"Description",
        accessor: "idpGroupDescription",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "description"
    },
    {
        heading:"Permission",
        accessor: "profileName",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "permission"
    }
];

export default IdentityProviderGroupColunms;
